// extracted by mini-css-extract-plugin
export var container = "_7k-0";
export var error = "_7k-9";
export var label = "_7k-5";
export var light = "_7k-6";
export var md = "_7k-3";
export var sm = "_7k-2";
export var thin = "_7k-8";
export var thinBold = "_7k-7";
export var vertical = "_7k-4";
export var xs = "_7k-1";